import React from 'react';
import axios from 'axios';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import PurchaseHistory from './purchase_history';

jest.mock('axios');

describe('PurchaseHistory', () => {
  test('renders PurchaseHistory component', async () => {
    const default_values = { beginning_of_month: '2020/12/1' , end_of_month: '2020/12/31' }
    const purchase_history_order_kbns = [{ name: '企業・店舗', value: 0},
                                         { name: '購入日時', value: 1}]
    const promise = Promise.resolve({
      data: {history_total_count: 1,
             purchase_histories: [{
               id: 1,
               company_name: "株式会社グッドな薬局",
               converted_created_at: "2020/01/01",
               converted_expired_at: "2021/01/01",
               ticket_name: "100回チケット",
               set_count: 2,
               price: 2000,
               init_count: 100,
               consumed_count: 0,
               expired_count: 0,
               remain_count: 0}]} });

    (axios.get as any).mockResolvedValue(promise);

    render(<PurchaseHistory default_values={default_values}
                            purchase_history_order_kbns={purchase_history_order_kbns} />);

    await act(() => promise);

    // screen.debug();

    expect(screen.getByText('チケット購入履歴')).toBeInTheDocument();
    expect(screen.getByText('株式会社グッドな薬局')).toBeInTheDocument();
  });
});
